// extracted by mini-css-extract-plugin
module.exports =  {"filter":"zPOHeWJKfoGH2qelqKt0"};